export const formDataConverter = (input: any) => {
  const formData = new FormData();
  formData.append('file', input[0]);
  return formData;
};
